import { Route, Routes } from "react-router-dom";
import { Suspense, lazy, useContext, useEffect } from "react";
import Loader from "../Components/kits/Loader/Loader.tsx";
// import ProtectedRoute from "./ProtectedRoute.tsx";
// import DiscountProduct from "pages/DiscountProduct.jsx";
// import AboutUs from "pages/AboutUs.jsx";
import Landing from "pages/Landing.jsx";

// const Home = lazy(() => import("../Components/Pages/Home/Home"));
// const Category = lazy(() => import("../Components/Pages/Category"));
// const Layout = lazy(() => import("../Components/layout/Layout"));
// const Profile = lazy(() => import("../Components/profile/Profile"));
// const CustomerOrders = lazy(() => import("../pages/CustomerOrders"));
// const AdminFactor = lazy(() => import("../pages/AdminFactor"));
// const PrintButton = lazy(() =>
//   import("../../src/Components/Pages/Home/barcode.jsx")
// );
// const UserManagement = lazy(() => import("../pages/User_Management"));
// const CategoryManagement = lazy(() =>
//   import("../Components/CategoryManagement/CategoryManagement")
// );
// const OptionManagement = lazy(() =>
//   import("../Components/admin-panel/option-management/OptionManagement")
// );
// const CustomerClub = lazy(() =>
//   import("../Components/customerClub/CustomerClub.js")
// );
// const Setting = lazy(() =>
//   import("../Components/admin-panel/setting/index.jsx")
// );
// const SingleProduct = lazy(() =>
//   import("../Components/Pages/single-product/SingleProduct")
// );
// const DetailPost = lazy(() => import("../pages/post/Index"));
// const Blog = lazy(() => import("../pages/Blog"));
// const FactorPage = lazy(() => import("../Components/Pages/FactorPage.jsx"));
// const Product = lazy(() => import("../pages/ProductListPage.jsx"));
// const Report = lazy(() => import("../Components/admin-panel/report"));
// const BankInfo = lazy(() => import("../Components/admin-panel/bank-info"));
export default function Router() {
  return (
    <Suspense
      fallback={
        <div className="min-vh-100 min-vw-100 d-flex justify-content-center align-items-center">
          <Loader width={40} />
        </div>
      }
    >
      <Routes>
        <Route
          path=""
          element={
            <Landing />
            // <Layout>
            //   <Home />
            // </Layout>
          }
        />
        {/* <Route
          path="blog/:id?"
          element={
            <Layout>
              <Blog />
            </Layout>
          }
        />
        <Route
          path="products"
          element={
            <Layout>
              <Product />
            </Layout>
          }
        />
        <Route
          path="category/:id"
          element={
            <Layout>
              <Category />
            </Layout>
          }
        />
        <Route
          path="admin-panel/orders"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <AdminFactor />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/user-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/category-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <CategoryManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/option-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <OptionManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/customer-club"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <CustomerClub />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="print"
          element={
            <Layout>
              <PrintButton selectedNumber={13791379} />
            </Layout>
          }
        />

        <Route
          path="admin-panel/setting"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <Setting />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/factors"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <FactorPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/reports"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <Report />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/bank-info"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <BankInfo />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/profile"
          element={
            <ProtectedRoute>
              <Layout pageType="user">
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/orders"
          element={
            <ProtectedRoute>
              <Layout pageType="user">
                <CustomerOrders />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="compare" element={<>compare</>} />
        <Route
          path="product/:id/:referral?"
          element={
            <Layout>
              <SingleProduct />
            </Layout>
          }
        />
        <Route
          path="blog/post/:id"
          element={
            <Layout>
              <DetailPost />
            </Layout>
          }
        />
        <Route
          path="discount-product"
          element={
            <Layout>
              <DiscountProduct />
            </Layout>
          }
        />
        <Route
          path="about-us"
          element={
            <Layout>
              <AboutUs />
            </Layout>
          }
        /> */}
      </Routes>
    </Suspense>
  );
}
